// @flow
import { SET_ERROR, CLEAR_ERROR } from '../actions'
import { ConditionName, ErrorAction } from '../actions'

export type Errors = ConditionName[]

export type ErrorState = {
  errors: Errors
}

const init: ErrorState = {
  errors: [],
}

export default function error(state: ErrorState = init, action: ErrorAction) {
  switch (action.type) {
    case SET_ERROR:
      return { ...state, errors: action.payload }
    case CLEAR_ERROR:
      return { ...state, errors: [] }
  }
  return state
}
